import { render, staticRenderFns } from "./stars.vue?vue&type=template&id=df023df6&"
import script from "./script/stars.js?vue&type=script&lang=js&"
export * from "./script/stars.js?vue&type=script&lang=js&"
import style0 from "./stars.vue?vue&type=style&index=0&id=df023df6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports